import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="admins--errors"
export default class extends Controller {
  close() {
    this.element.remove()
  }
}
